import styled from 'styled-components'
import React from 'react';

import Icon from '../reusable/Icon'


const MiddlePopup = ({ open, onClose, onAction, children, actionText, close, title }) => {

  return(
    <PopupLayer open={open}>
      <PopupWrapper open={open}>
          {close && 
            <Close onClick={onClose}>
              <Icon icon="close" width={15} />
            </Close>
          }
            <PopupContent>
              <PopupTitle>{title}</PopupTitle>
              <Overflow>
                {children}
              </Overflow>
            </PopupContent>
          <PopupButton onClick={onAction}>{actionText}</PopupButton>
      </PopupWrapper>
    </PopupLayer>
  )
}

export default MiddlePopup



const Close = styled.div(props => ({
  position:"absolute",
  top:15,
  right:14,
  transition:"0.2s ease-in-out",
  ":hover":{
    transform:"scale(1.2)",
    cursor:"pointer",
  }
}));

const PopupLayer = styled.div(props => ({
  position:"fixed",
  top:0,
  left:0,
  bottom:0,
  right:0,
  zIndex:3,
  background:"rgba(0,0,0,0.5)",
  display:"flex",
  justifyContent:"center",
  alignItems:"center",
  flexDirection:"column",
  transition:"0.2s visibility 0s, 0.2s opacity 0.2s",
  visibility: props.open ? "visible":"hidden",
  opacity: props.open ? 1:0,
}));

const Overflow = styled.div(props => ({
  overflowY:"scroll",
  maxHeight:"calc(100vh - 200px)",
  "@media (max-width: 550px)": {
    maxHeight:"calc(100vh - 190px)",
  }
}));

const PopupWrapper = styled.div(props => ({
  position:"relative",
  transform: props.open ? "scale(1)":"scale(0)",
  transition:"0.2s ease-in-out 0.2s",
  zIndex:2,
  background:"#fff",
  width:"calc(100% - 20px)",
  maxWidth:600,
  minWidth:300,
  boxShadow: "0px 8px 40px rgba(0, 0, 0, 0.03)",
  overflow:"hidden",
  "@media (max-width: 550px)": {
    width:"calc(100%)",
    position:"absolute",
    transform: "scale(1)",
    bottom:props.open ? 0 : -100,
    right:0,
    borderBottomLeftRadius:0,
    borderBottomRightRadius:0,
  }
}));

export const PopupTitle = styled.h2(props => ({
  textAlign:"center",
  color:"#5B5B5B",
  fontSize:30,
  marginBottom:40,
  fontWeight:500,
  marginTop:0,
  lineHeight: "30px",
  whiteSpace:"nowrap",
  "@media (max-width: 550px)": {
    whiteSpace:"normal",
    fontSize:20,
    marginBottom:30,
  }
}));

const PopupContent = styled.div(props => ({
  padding:"40px 70px",
  color:"#000",
  textAlign:"center",
  margin:"0 auto",
  fontSize:14,
  "@media (max-width: 550px)": {
    padding:"20px 30px",
  }
}));

export const PopupButton = styled.div(props => ({
  width:"100%",
  height:50,
  background:props.theme.colors.primary,
  color:"#fff",
  fontSize:18,
  fontWeight:400,
  display:"flex",
  justifyContent:"center",
  alignItems:"center",
  cursor:"pointer",
  margin:0,
  transition:"0.2s ease-in-out",
  ":hover":{
    opacity:0.8,
  },
  "@media (max-width: 550px)": {
    margin:20,
    width:"calc(100% - 40px)",
    borderRadius:10,
  }
}));

